// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css */

.custom-header {
  background: linear-gradient(135deg, #5b9942 30%, #5b9942 70%, #5b9942 100%) !important;
  box-shadow: 0 4px 20px rgba(51, 105, 30, 0.4) !important;
  z-index: 1201 !important;
}

.header-toolbar {
  min-height: 70px !important;
  padding: 0 24px !important;
  justify-content: space-between !important;
  display: flex !important;
}

/* Desktop nav */
@media (min-width: 960px) {
  .header-nav {
    display: flex !important;
  }
}

/* Mobile toolbar padding */
@media (max-width: 960px) {
  .header-toolbar {
    padding: 0 16px !important;
    min-height: 56px !important;
  }
}

@media (max-width: 600px) {
  .header-toolbar {
    padding: 0 12px !important;
    min-height: 52px !important;
  }
}

/* Drawer scrollbar */
.MuiDrawer-paper::-webkit-scrollbar {
  width: 4px;
}

.MuiDrawer-paper::-webkit-scrollbar-track {
  background: transparent;
}

.MuiDrawer-paper::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

/* Drawer slide animation */
.MuiDrawer-root .MuiDrawer-paper {
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Language menu items */
.MuiMenu-root .MuiMenuItem-root {
  border-radius: 8px;
  margin: 2px 4px;
  padding: 8px 12px;
}

/* Accessibility focus ring */
.MuiListItemButton-root:focus-visible {
  outline: 2px solid #ffc022;
  outline-offset: -2px;
  border-radius: 8px;
}

.MuiButton-root:focus-visible {
  outline: 2px solid #ffc022;
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/Header.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,sFAAsF;EACtF,wDAAwD;EACxD,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,mEAAmE;AACrE;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Header.css */\n\n.custom-header {\n  background: linear-gradient(135deg, #5b9942 30%, #5b9942 70%, #5b9942 100%) !important;\n  box-shadow: 0 4px 20px rgba(51, 105, 30, 0.4) !important;\n  z-index: 1201 !important;\n}\n\n.header-toolbar {\n  min-height: 70px !important;\n  padding: 0 24px !important;\n  justify-content: space-between !important;\n  display: flex !important;\n}\n\n/* Desktop nav */\n@media (min-width: 960px) {\n  .header-nav {\n    display: flex !important;\n  }\n}\n\n/* Mobile toolbar padding */\n@media (max-width: 960px) {\n  .header-toolbar {\n    padding: 0 16px !important;\n    min-height: 56px !important;\n  }\n}\n\n@media (max-width: 600px) {\n  .header-toolbar {\n    padding: 0 12px !important;\n    min-height: 52px !important;\n  }\n}\n\n/* Drawer scrollbar */\n.MuiDrawer-paper::-webkit-scrollbar {\n  width: 4px;\n}\n\n.MuiDrawer-paper::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.MuiDrawer-paper::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n}\n\n/* Drawer slide animation */\n.MuiDrawer-root .MuiDrawer-paper {\n  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n/* Language menu items */\n.MuiMenu-root .MuiMenuItem-root {\n  border-radius: 8px;\n  margin: 2px 4px;\n  padding: 8px 12px;\n}\n\n/* Accessibility focus ring */\n.MuiListItemButton-root:focus-visible {\n  outline: 2px solid #ffc022;\n  outline-offset: -2px;\n  border-radius: 8px;\n}\n\n.MuiButton-root:focus-visible {\n  outline: 2px solid #ffc022;\n  outline-offset: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
